<template>
  <div>
    <section-header heading="2" ja="有料会員を解約するには"/>
    <div class="textArea">
      <p>
        有料会員を解約する場合、<br>以下の手順で解約手続きをお願いします。<br>
        アプリをアンインストールしても、解約されませんので<br>ご注意ください。
      </p>
      <p>
        ■アプリ内課金の場合<br>
        <template v-if="isIOS">
          ・App Store(iOS)で契約した場合<br>
          有料会員登録した Apple ID で<br>以下の手順で解約手続きをお願いします。<br>
          <a
            class="textLink"
            href="unity:command?openurl=https://support.apple.com/ja-jp/HT202039">
            https://support.apple.com/ja-jp/HT202039
          </a><br>
          ・有料会員の自動更新をしたくない場合は、更新日の24時間以上前に、サブスクリプションのキャンセルをしてください。<br>
          →サブスプリクションのキャンセル後も、更新日までは、有料会員として当サービスをご利用いただけます。<br>
          ・自動更新および自動更新時の課金は、有効期間の終了後24時間以内に行われます。
        </template>
        <template v-else>
          ・Google Play(Android)で契約した場合<br>
          有料会員登録した Google アカウント で<br>
          <a class="textLink" href="unity:command?openurl=https://play.google.com/store/account/subscriptions">こちら</a>から解約手続きをお願いします。<br>
          ・有料会員の自動更新をしたくない場合は、更新日の前日までに、定期購入の解約をしてください。<br>
          ・解約後も更新日までは、有料会員として当サービスをご利用いただけます。
        </template>
      </p>
      <p>
        ■WEB決済の場合<br>
        プロフィール設定の会員状態から「変更する」を選択して、解約手続きをお願いします。
      </p>
      <p>
        ・WEB決済の有料会員の解約操作をされた場合、その月の月末で解約となります。<br>
        ・有料会員の自動更新をしたくない場合は、月末までに、解約手続きをしてください。<br>
        ・解約操作後もその月の月末までは、有料会員として当サービスをご利用いただけます。<br>
        ・決済方法をd払いでの有料会員の登録直後に、すぐに有料会員の解約をしようとすると、エラーとなる場合がございます。<br>
        その場合には1時間ほど待ってから、あらためて解約ができないかをお試しください。
      </p>
    </div>
    <sub-btn @click="onAboutWeb()">戻る</sub-btn>
  </div>
</template>

<script>
import SectionHeader from "../components/SectionHeader"
import SubBtn from '@/components/SubBtn.vue'
import { isIOS } from "../assets/js/util"

export default {
  name: "AppAboutAppsubscription",
  components: {
    SectionHeader,
    SubBtn
  },
  data () {
    return { isIOS: null }
  },
  mounted() {
    this.isIOS = isIOS();
  },
  methods: {
    onAboutWeb() {
      this.$router.push("/AppaboutWeb10")
    },
  }
}
</script>

<style lang="scss" scoped>
.textArea {
  margin: 30px 30px 0;
  font-size: 12px;
  color: #373737;
  p {
    margin-top: 1em;
  }
}
.textLink {color: #DA2240;}
</style>
